import type ordersEn from "./orders.en";

const ordersAr: Record<keyof typeof ordersEn, string> = {
  "ord.title": "الطلبات",
  "ord.create": "إنشاء طلب",
  "ord.empty_title": "ستظهر طلباتك هنا",
  "ord.empty_body": "تظهر هنا طلبات واجهة متجرك والطلبات اليدوية التي تنشئها لمبيعات الهاتف أو واتساب.",
  "ord.none": "لا توجد طلبات تطابق هذه الفلاتر.",
  "ord.search": "ابحث برقم الطلب أو العميل أو البريد أو الهاتف أو المنتج",
  "ord.tab.all": "الكل",
  "ord.tab.unfulfilled": "غير منفّذة",
  "ord.tab.unpaid": "غير مدفوعة",
  "ord.tab.open": "مفتوحة",
  "ord.tab.archived": "مؤرشفة",
  "ord.tab.cod": "دفع عند الاستلام للتحصيل",
  "ord.sort.-processed_at": "الأحدث",
  "ord.sort.processed_at": "الأقدم",
  "ord.sort.-total": "الإجمالي: من الأعلى",
  "ord.sort.total": "الإجمالي: من الأقل",
  "ord.sort.-number": "رقم الطلب: من الأعلى",
  "ord.sort.number": "رقم الطلب: من الأقل",
  "ord.filter.payment": "حالة الدفع",
  "ord.filter.fulfillment": "حالة التنفيذ",
  "ord.filter.delivery": "طريقة التوصيل",
  "ord.fin.pending": "الدفع معلّق",
  "ord.fin.authorized": "مصرّح",
  "ord.fin.partially_paid": "مدفوع جزئياً",
  "ord.fin.paid": "مدفوع",
  "ord.fin.partially_refunded": "مسترد جزئياً",
  "ord.fin.refunded": "مسترد",
  "ord.fin.voided": "ملغى",
  "ord.ful.unfulfilled": "غير منفّذ",
  "ord.ful.partially_fulfilled": "منفّذ جزئياً",
  "ord.ful.fulfilled": "منفّذ",
  "ord.ful.scheduled": "مجدول",
  "ord.ful.on_hold": "معلّق",
  "ord.delivery.shipping": "شحن",
  "ord.delivery.local_delivery": "توصيل محلي",
  "ord.delivery.pickup": "استلام",
  "ord.delivery.none": "بدون توصيل",
  "ord.col.order": "الطلب",
  "ord.col.date": "التاريخ",
  "ord.col.customer": "العميل",
  "ord.col.total": "الإجمالي",
  "ord.col.payment": "الدفع",
  "ord.col.fulfillment": "التنفيذ",
  "ord.col.items": "المنتجات",
  "ord.col.delivery": "طريقة التوصيل",
  "ord.col.tags": "الوسوم",
  "ord.no_customer": "بدون عميل",
  "ord.cancelled": "ملغى",
  "ord.items": "{n} منتجات",
  "ord.source.web": "واجهة المتجر",
  "ord.source.draft": "طلب يدوي",
  "ord.source.api": "واجهة برمجية",
  "ord.source.pos": "نقطة البيع",
  "ord.state.archived": "مؤرشف",
  "ord.cancelled_banner": "تم إلغاء هذا الطلب. السبب: {reason}.",
  "ord.reason.customer": "العميل غيّر الطلب أو ألغاه",
  "ord.reason.inventory": "منتجات غير متوفرة",
  "ord.reason.fraud": "طلب احتيالي",
  "ord.reason.declined": "تم رفض الدفع",
  "ord.reason.staff": "خطأ من الموظفين",
  "ord.reason.other": "أخرى",
  "ord.more_actions": "إجراءات أخرى",
  "ord.duplicate": "تكرار",
  "ord.print_slip": "طباعة قائمة التعبئة",
  "ord.view_status_page": "عرض صفحة حالة الطلب",
  "ord.archive": "أرشفة",
  "ord.unarchive": "إلغاء الأرشفة",
  "ord.archived": "تمت أرشفة الطلب",
  "ord.unarchived": "تم إلغاء أرشفة الطلب",
  "ord.cancel": "إلغاء الطلب",
  "ord.refund": "استرداد",
  "ord.removed": "محذوفة",
  "ord.items_title": "المنتجات",
  "ord.notes": "ملاحظات",
  "ord.no_notes": "لا توجد ملاحظات من العميل",
  "ord.attributes": "تفاصيل إضافية",
  "ord.on_hold": "معلّق",
  "ord.ready_for_pickup": "جاهز للاستلام",
  "ord.unfulfilled_n": "غير منفّذ ({n})",
  "ord.fulfilled_n": "منفّذ ({n})",
  "ord.picked_up_n": "تم الاستلام ({n})",
  "ord.release_hold": "رفع تعليق التنفيذ",
  "ord.hold": "تعليق التنفيذ",
  "ord.hold_released": "تم رفع تعليق التنفيذ",
  "ord.held": "تم تعليق التنفيذ",
  "ord.hold.awaiting_payment": "بانتظار الدفع",
  "ord.hold.awaiting_confirmation": "بانتظار تأكيد العميل",
  "ord.hold.high_risk": "خطر احتيال مرتفع",
  "ord.hold.incorrect_address": "عنوان غير صحيح",
  "ord.hold.inventory_out_of_stock": "المخزون نافد",
  "ord.hold.other": "أخرى",
  "ord.hold_title": "تعليق التنفيذ",
  "ord.hold_body": "لا يمكن تنفيذ المنتجات المعلّقة حتى ترفع التعليق.",
  "ord.hold_reason": "السبب",
  "ord.mark_picked_up": "تحديد كمستلَم",
  "ord.mark_ready": "تحديد كجاهز للاستلام",
  "ord.picked_up_done": "تم التحديد كمستلَم",
  "ord.ready_done": "تم التحديد كجاهز للاستلام وإبلاغ العميل",
  "ord.fulfill_items": "تنفيذ المنتجات",
  "ord.deliver_items": "توصيل المنتجات",
  "ord.shipment.in_transit": "قيد النقل",
  "ord.shipment.out_for_delivery": "خرج للتوصيل",
  "ord.shipment.attempted_delivery": "محاولة توصيل",
  "ord.shipment.delivered": "تم التوصيل",
  "ord.shipment.failure": "فشل التوصيل",
  "ord.shipment.picked_up": "تم الاستلام",
  "ord.mark_shipment": "تحديد كـ {status}",
  "ord.add_tracking": "إضافة تتبّع",
  "ord.edit_tracking": "تعديل التتبّع",
  "ord.cancel_fulfillment": "إلغاء التنفيذ",
  "ord.cancel_fulfillment_title": "إلغاء التنفيذ {name}؟",
  "ord.cancel_fulfillment_body": "تعود المنتجات إلى غير منفّذة ويُحجز مخزونها مرة أخرى.",
  "ord.fulfillment_cancelled": "تم إلغاء التنفيذ",
  "ord.subtotal": "المجموع الفرعي",
  "ord.discount": "الخصم",
  "ord.shipping": "الشحن",
  "ord.taxes": "الضرائب",
  "ord.taxes_included": "الضرائب (مشمولة)",
  "ord.payment_fee": "رسوم الدفع",
  "ord.tip": "الإكرامية",
  "ord.total": "الإجمالي",
  "ord.paid_by_customer": "مدفوع من العميل",
  "ord.refunded": "مسترد",
  "ord.net_payment": "صافي الدفع",
  "ord.balance": "المتبقي",
  "ord.cod_to_collect": "نقداً عند التوصيل",
  "ord.show_transactions": "عرض المعاملات ({n})",
  "ord.hide_transactions": "إخفاء المعاملات",
  "ord.mark_paid": "تحديد كمدفوع",
  "ord.collect_cod": "تأكيد تحصيل النقد",
  "ord.mark_paid_title": "تحديد كمدفوع؟",
  "ord.mark_paid_body": "سيُسجَّل دفع يدوي بقيمة {amount}. لا يمكن التراجع عن ذلك.",
  "ord.marked_paid": "تم تحديد الطلب كمدفوع",
  "ord.txn.success": "ناجحة",
  "ord.txn.pending": "معلّقة",
  "ord.txn.failure": "فاشلة",
  "ord.txn.error": "خطأ",
  "ord.txn_kind.sale": "بيع",
  "ord.txn_kind.refund": "استرداد",
  "ord.txn_kind.authorization": "تصريح",
  "ord.txn_kind.capture": "تحصيل",
  "ord.txn_kind.void": "إلغاء",
  "ord.txn_kind.chargeback": "اعتراض",
  "ord.txn_kind.chargeback_reversal": "عكس الاعتراض",
  "ord.txn_kind.change": "باقي",
  "ord.method.cod": "الدفع عند الاستلام",
  "ord.method.skipcash": "SkipCash",
  "ord.method.sadad": "سداد",
  "ord.method.myfatoorah": "ماي فاتورة",
  "ord.method.tap": "Tap Payments",
  "ord.method.paylater": "PayLater",
  "ord.method.tabby": "تابي",
  "ord.method.tamara": "تمارا",
  "ord.method.bank_transfer": "تحويل بنكي",
  "ord.method.manual": "يدوي",
  "ord.test": "تجريبي",
  "ord.customer": "العميل",
  "ord.customer_orders": "{n} طلبات",
  "ord.contact": "معلومات التواصل",
  "ord.no_email": "لا يوجد بريد إلكتروني",
  "ord.whatsapp": "مراسلة عبر واتساب",
  "ord.shipping_address": "عنوان الشحن",
  "ord.billing_address": "عنوان الفوترة",
  "ord.no_address": "لا يوجد عنوان",
  "ord.view_map": "عرض الخريطة",
  "ord.pickup_at": "موقع الاستلام",
  "ord.same_as_shipping": "نفس عنوان الشحن",
  "ord.marketing_yes": "مشترك في التسويق عبر البريد",
  "ord.marketing_no": "غير مشترك في التسويق عبر البريد",
  "ord.tags": "الوسوم",
  "ord.tags_placeholder": "أضف وسوماً",
  "ord.timeline": "السجل الزمني",
  "ord.comment_placeholder": "اكتب تعليقاً…",
  "ord.comment_hint": "التعليقات مرئية لك وللموظفين فقط",
  "ord.post": "نشر",
  "ord.staff": "موظف",
  "ord.keep_order": "إبقاء الطلب",
  "ord.cancel_title": "إلغاء الطلب {name}؟",
  "ord.cancel_refund": "استرداد {amount}",
  "ord.refund_gateway_hint": "تُسترد المدفوعات الإلكترونية من حسابك في {name}؛ هنا يُسجَّل الاسترداد فقط.",
  "ord.restock_items": "إعادة المنتجات إلى المخزون",
  "ord.cancel_reason": "سبب الإلغاء",
  "ord.staff_note": "ملاحظة الموظفين",
  "ord.notify_customer": "إرسال إشعار إلى العميل",
  "ord.cancelled_done": "تم إلغاء الطلب",
  "ord.tracking_number": "رقم التتبّع",
  "ord.carrier": "شركة الشحن",
  "ord.carrier_other": "أخرى",
  "ord.carrier_name": "اسم شركة الشحن",
  "ord.tracking_url": "رابط التتبّع",
  "ord.notify_tracking": "إرسال تحديث الشحن إلى العميل",
  "ord.tracking_saved": "تم تحديث التتبّع",
  "ord.edit_note": "تعديل الملاحظة",
  "ord.edit_contact": "تعديل معلومات التواصل",
  "ord.email": "البريد الإلكتروني",
  "ord.phone": "الهاتف",
  "ord.contact_hint": "تنطبق التغييرات على هذا الطلب فقط وليس على ملف العميل.",
  "ord.edit_shipping_address": "تعديل عنوان الشحن",
  "ord.ship_to": "الشحن إلى",
  "ord.qty": "الكمية",
  "ord.back": "العودة إلى الطلب",
  "ord.nothing_to_fulfill": "تم تنفيذ كل منتجات هذا الطلب.",
  "ord.fulfill_title": "تنفيذ {name}",
  "ord.of_n": "من {n}",
  "ord.tracking": "معلومات التتبّع",
  "ord.summary": "الملخص",
  "ord.fulfilling_n": "تنفيذ {n} منتجات من {loc}",
  "ord.notify_out_for_delivery": "إبلاغ العميل بخروج الطلب للتوصيل",
  "ord.notify_shipment": "إرسال تفاصيل الشحنة إلى العميل",
  "ord.send_out_n": "إرسال {n} منتجات للتوصيل",
  "ord.fulfill_n": "تنفيذ {n} منتجات",
  "ord.out_for_delivery_done": "خرج للتوصيل",
  "ord.fulfilled_done": "تم تنفيذ المنتجات",
  "ord.refund_title": "استرداد {name}",
  "ord.fulfilled_count": "{n} منفّذة",
  "ord.all_refunded": "تم استرداد كل المنتجات مسبقاً.",
  "ord.restock_n": "إعادة {n} منتجات إلى المخزون",
  "ord.refund_shipping": "استرداد الشحن",
  "ord.shipping_amount": "مبلغ الشحن",
  "ord.shipping_left": "{amount} متبقٍ للاسترداد",
  "ord.refund_reason": "سبب الاسترداد",
  "ord.refund_reason_hint": "مرئي لك وللموظفين فقط",
  "ord.items_subtotal": "مجموع المنتجات",
  "ord.refund_total": "إجمالي الاسترداد",
  "ord.refund_amount": "مبلغ الاسترداد",
  "ord.available_refund": "{amount} متاح للاسترداد",
  "ord.refund_unpaid_hint": "لم يُحصَّل شيء بعد: حذف المنتجات يقلّل المبلغ المستحق.",
  "ord.refund_amount_btn": "استرداد {amount}",
  "ord.remove_items": "حذف المنتجات",
  "ord.refunded_done": "تم تسجيل الاسترداد",
  "draft.title": "الطلبات اليدوية",
  "draft.create": "إنشاء طلب",
  "draft.empty_title": "استقبل الطلبات عبر الهاتف أو واتساب",
  "draft.empty_body": "أنشئ طلبات لعملائك وأضف منتجات مخصصة وخصومات، ثم حدّدها كمدفوعة أو معلّقة الدفع.",
  "draft.tab.all": "الكل",
  "draft.tab.open": "مفتوحة",
  "draft.tab.completed": "مكتملة",
  "draft.search": "ابحث في الطلبات اليدوية",
  "draft.none": "لا توجد طلبات يدوية.",
  "draft.col.draft": "المسودة",
  "draft.col.date": "التاريخ",
  "draft.col.customer": "العميل",
  "draft.col.status": "الحالة",
  "draft.col.total": "الإجمالي",
  "draft.completed": "مكتملة",
  "draft.open": "مفتوحة",
  "draft.new": "إنشاء طلب",
  "draft.delete_title": "حذف هذا الطلب اليدوي؟",
  "draft.delete_body": "لا يمكن التراجع عن ذلك.",
  "draft.view_order": "عرض الطلب",
  "draft.completed_banner": "أصبح هذا الطلب اليدوي الطلب {name}.",
  "draft.products": "المنتجات",
  "draft.custom_item": "إضافة منتج مخصص",
  "draft.search_products": "ابحث عن المنتجات أو تصفّحها",
  "draft.no_items": "أضف منتجات لبدء الطلب.",
  "draft.custom": "منتج مخصص",
  "draft.low_stock": "المتوفر {n} فقط",
  "draft.payment": "الدفع",
  "draft.add_discount": "إضافة خصم",
  "draft.edit_discount": "الخصم",
  "draft.add_shipping": "إضافة شحن",
  "draft.edit_shipping": "الشحن",
  "draft.tax_exempt_short": "لا تُحصَّل",
  "draft.tax_exempt": "عدم تحصيل الضرائب",
  "draft.save": "حفظ المسودة",
  "draft.saved": "تم حفظ المسودة",
  "draft.collect_payment": "تحصيل الدفع",
  "draft.mark_paid": "تحديد كمدفوع",
  "draft.mark_pending": "تحديد كمعلّق الدفع",
  "draft.mark_paid_body": "سيُنشأ الطلب مع تسجيل {amount} كمدفوع.",
  "draft.mark_pending_body": "سيُنشأ الطلب مع {amount} للتحصيل لاحقاً (عند الاستلام أو بالتحويل).",
  "draft.create_order": "إنشاء الطلب",
  "draft.order_created": "تم إنشاء الطلب {name}",
  "draft.note_placeholder": "أضف ملاحظة إلى هذا الطلب",
  "draft.search_customers": "ابحث عن عميل أو أضفه",
  "draft.no_customers": "لا يوجد عملاء",
  "draft.add": "إضافة المنتج",
  "draft.item_name": "اسم المنتج",
  "draft.price": "السعر",
  "draft.taxable": "المنتج خاضع للضريبة",
  "draft.physical": "منتج مادي",
  "draft.line_discount": "خصم المنتج",
  "draft.remove_discount": "إزالة الخصم",
  "draft.apply": "تطبيق",
  "draft.discount_type": "نوع الخصم",
  "draft.percentage": "نسبة مئوية",
  "draft.amount_per_item": "مبلغ لكل قطعة ({currency})",
  "draft.amount": "مبلغ ({currency})",
  "draft.value": "القيمة",
  "draft.reason": "السبب",
  "draft.reason_hint": "يرى عميلك هذا السبب",
  "draft.shipping": "الشحن",
  "draft.remove_shipping": "إزالة الشحن",
  "draft.rate_name": "اسم السعر",
  "draft.rate_placeholder": "مثال: مندوب توصيل",
};

export default ordersAr;
